import React from "react";
import { makeStyles } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";

const useStyles = makeStyles((theme) => ({
  cross: {
    cursor: "pointer",
    float: "right",
    color: "#f76f6f",
  },
  contentContainer: {
    height: "90%",
    width: "100%",
    justifyContent: "center",
    display: "flex",
  },
  previewImage: {
    maxHeight: "100%",
    maxWidth: "100%",
  },
}));

export default function ViewRecordModal({ isOpen, onClose, record }) {
  const classes = useStyles();
  const [viewerUrl, setViewerUrl] = React.useState(null);

  React.useEffect(() => {
    if (!record) return;

    const url = new URL(record.toLowerCase());
    const path = url.pathname;

    if (
      path.endsWith(".pdf") ||
      path.endsWith(".doc") ||
      path.endsWith(".docx") ||
      path.endsWith(".xls") ||
      path.endsWith(".xlsx")
    ) {
      setViewerUrl(
        `https://docs.google.com/viewer?url=${encodeURIComponent(record)}`
      );
    } else {
      setViewerUrl(null);
    }
  }, [record]);

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Preview Document
        <span className={classes.cross} onClick={onClose}>
          Close
        </span>
      </DialogTitle>
      <DialogContent>
        {record ? (
          <div className={classes.contentContainer}>
            {viewerUrl ? (
              <a href={viewerUrl} target="_blank" rel="noopener noreferrer">
                <u>Click to View Pdf/Document file</u>
              </a>
            ) : (
              <img
                className={classes.previewImage}
                src={record}
                alt="document"
              />
            )}
          </div>
        ) : (
          <p>No record to preview.</p>
        )}
      </DialogContent>
    </Dialog>
  );
}
